import { AddEditBoxApi } from './AddEditBoxApi'
import { boxManagementGo } from './boxMangementGo'
import { masterPortal } from './masterPortal'
import { VendorUserApi } from './VendorUserApi'
import { ChangePassApi } from './ChangePassApi'
import { OtaUpdateApi } from './OtaUpdateApi'
const ApiCalls={
    AddEditBoxApi,
    boxManagementGo,
    masterPortal,
    VendorUserApi,
    ChangePassApi,
    OtaUpdateApi
}
export {ApiCalls}